export class Registration{
    public ID: number;
    public HashCode: string;
    public Board: string;
    public Medium: string;
    public InstituteTypeID: string;
    public UDiseNo: string;
    public SSCIndexNo: string="";
    public HSCIndexNO: string="";
    public Office: number;
    public TypeOfTrust: number;
    public AcquiredDate: Date;
    public Section: string;
    public Area: string;
    public State: number;
    public City: number;
    public Trust: string;
    public TrustAddress:string;
    public TrustMobileNo: string;
    public TrustMailID: string;
    public SchoolName: string;
    public SchoolAddress: string;
    public SchoolMobileno: string;
    public SchoolMailID: string;
    public SchoolLocation: number;
    public SchoolType: number;
    public RegistrationDate: string;
    public TrusteeName: string = "";
    public TrusteeAddress: string= "";
    public TrusteeMobileNo: string= "";
    public TrusteeMailID: string= "";
    public TrusteeDetail: Array<any> = [];
    public DesignationID: number;
    public PrinDesignation: string;
    public PrincipalName: string= "";
    public PrincipalMobileNo: string= "";
    public PrincipalMailID: string= "";
    public PrincipalDetail: Array<any> = [];
    public AuthorizedPerson: string;
    public Designation: string;
    public MobileNo: string;
    public WhatsAppNo: string;
    public playGroup: number;
    public nursery: number;
    public jrkg: number;
    public srkg: number;
    public std1: number;
    public std2: number;
    public std3: number;
    public std4: number;
    public std5: number;
    public std6: number;
    public std7: number;
    public std8: number;
    public std9: number;
    public std10: number;
    public std11sci: number;
    public std12sci: number;
    public std11com: number;
    public std12com: number;
    public std11arts: number;
    public std12arts: number;
    public StandardDetails: Array<any> = [];
    public OwnerName: string = "";
    public OwnerMobileNo: string= "";
    public OwnerMailID: string= "";
    public OwnerDetail: Array<any> = [];
    public LandArea: number;
    public LandConstruction: number;
    public PendingSalaryIncrementAmount: number;
    public PendingSalaryIncrementDescription: string ="";
    public DepreciationAmount: number;
    public DepreciationDescription: string ="";
    public Remarks: string ="";
    public RequestStatus: number;
    public AffiliationNumber: string;
    public AffiliationNumberAcquireDate : Date;
    public YearID: number;
    public InfrastructureID: number;
    public NoOfInfrastructure: number;
    public InfrastructureSize: number;
    public InfrastructureDetail: Array<any> = [];
    public EmployeeTypeID: number;
    public NoOfPermanentEmployee: number;
    public NoOfAdhocEmployee: number;
    public TotalPermanentSalary: number;
    public TotalAdhocSalary: number;
    public EmployeeDetail: Array<any> = [];
    public NoOfClassroom: number;
    public ClassroomDetail: Array<any> = [];
    public QualificationID: number;
    public NoofEmployee: number;
    public EmployeeQualificationDetail: Array<any> = [];
    public Pincode:string;
}